// Password checklist Item Component
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";

export default function ValidationItem({ fulfilled, text }) {
  return (
    <ListItem sx={{ py: 0, px: 1 }}>
      <ListItemIcon sx={{ minWidth: 30 }}>
        {fulfilled ? (
          <CheckCircleOutlineIcon color="success" fontSize="small" />
        ) : (
          <HighlightOffIcon color="error" fontSize="small" />
        )}
      </ListItemIcon>
      <ListItemText
        primary={text}
        slotProps={{
          primary: {
            variant: "caption",
            color: fulfilled ? "success.main" : "error.main",
          },
        }}
      />
    </ListItem>
  );
}
